import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminEntityListPage from "@/components/admin/admin-entity-list-page";

const AdminWorkspacesListPage = (): JSX.Element => <AdminEntityListPage kind="workspaces" />;

export const Route = createFileRoute("/_app/admin/workspaces/")({
	component: AdminWorkspacesListPage,
});
